/// <amd-module name="Repos/Views/FilesHub/Components/HighlightChanges" />
import * as React from "react";
import { IDiffViewerProps, IFileContentDetails } from "Repos/Common/Contracts/Editor";
import { IGitItemContent } from "Repos/Files/Contracts";
import * as Resources from "Repos/Views/FilesHub/Resources";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { HeaderCommandBar } from "VSSUI/HeaderCommandBar";
import { Observer } from "VSSUI/Observer";
import { IFilesHubViewService, registerFilesHubTab } from "../FilesHubViewService";

export class HighlightChanges extends VssComponent<{}> {
    public render() {
        const filesService = this.context.pageContext.getService<IFilesHubViewService>("IFilesHubViewService");
        return (
            <Observer originalContent={filesService.getSelectedItemContent()}>
                {(contentProps: { originalContent: IGitItemContent | undefined }) => {
                    let modifiedContent: IFileContentDetails | undefined;
                    if (contentProps.originalContent) {
                        modifiedContent = contentProps.originalContent.details;
                        if (contentProps.originalContent.editContext) {
                            modifiedContent = {
                                content: contentProps.originalContent.editContext.getContent(),
                                contentTruncated: contentProps.originalContent.details.contentTruncated,
                                metadata: contentProps.originalContent.details.metadata,
                                objectId: contentProps.originalContent.details.objectId,
                                resourceUri: contentProps.originalContent.details.resourceUri
                            };
                        }
                    }
                    return (
                        <Card className="no-padding flex-grow v-scroll-hidden" contentProps={{ contentPadding: false }}>
                            {contentProps.originalContent ? (
                                <WrappedComponent<IDiffViewerProps>
                                    wrappedType="repos-diff-viewer"
                                    dependencies={["ms.vss-code-web.code-editor"]}
                                    wrappedProps={{
                                        addDiffKeyboardShortcuts: false,
                                        className: "flex-column flex-grow",
                                        diffOrientation: filesService.getDiffOrientation(),
                                        editable: true,
                                        editorClassName: "repos-file-editor-background scroll-hidden",
                                        isPixelDiff: false,
                                        modifiedContent: modifiedContent!,
                                        onContentChanged: this.onContentChanged,
                                        originalContent: contentProps.originalContent.details
                                    }}
                                />
                            ) : (
                                <div className="repos-file-editor-background flex-grow" />
                            )}
                        </Card>
                    );
                }}
            </Observer>
        );
    }

    private onContentChanged = (content: string): void => {
        const filesService = this.context.pageContext.getService<IFilesHubViewService>("IFilesHubViewService");
        const itemContent = filesService.getSelectedItemContent();

        if (itemContent.value && itemContent.value.editContext) {
            itemContent.value.editContext.setContent(content);
        }
    };
}

registerFilesHubTab({
    getTab: (pageContext, item, editMode) => {
        if (editMode && !item.isFolder && !item.isNewItem) {
            return {
                id: "diff",
                name: Resources.HighlightChanges,
                order: 20,
                render: () => {
                    return <HighlightChanges />;
                },
                renderFilterBar: (inTabBar: boolean) => {
                    const filesService = pageContext.getService<IFilesHubViewService>("IFilesHubViewService");
                    return inTabBar ? (
                        <Observer diffOrientation={filesService.getDiffOrientation()}>
                            {() => <HeaderCommandBar items={[filesService.getDiffOrientationMenuItem()]} />}
                        </Observer>
                    ) : undefined;
                }
            };
        }
    }
});
